import _ from "lodash";
import Calculator, { CHANNEL_CALCULATIONS_UPDATED } from "@ambifi/ambifi-lib-calculator";
import RulesEngine from "@ambifi/ambifi-lib-rules-engine";
import PubSub from "pubsub-js";
import matchReplaceAll from "match-replace-all";
import * as Utils from "../utils/utils";

import RuntimeApi from "../runtimeEngine/runtimeApi";
import { getCurrentActivityKeyPath, getObjectByGuid, clearPathCaches } from "./modelActions";
import { getVariables, setValueIfHasId } from "./variableActions";
import state from "../state";

const PROP_CALCULATIONS = "calculations";
const PROP_RULES = "rules";
const PROP_APP_STATE = "appState";
const PROP_CHILDREN = "children";

let services = {};

const PROP_IFTTT = "ifttt";
const STRING_TEMPLATE_VARIABLE = new RegExp("\\$\\{(.*?)}", "gm");
export function resolveIntegration(integration, _item) {
	const item = _.assign({}, _item);
	if (!item.hasOwnProperty("id") || _.isEmpty(item.id)) {
		item.id = item.guid;
	}
	const self = item; // eslint-disable-line
	let result = integration;
	const strIntegration = JSON.stringify(integration);
	if (strIntegration.indexOf("${") !== -1) {
		try {
			// // console.log("IFTTT about to resolve", integration, self);
			const resolvedStrIntegration = matchReplaceAll(STRING_TEMPLATE_VARIABLE, strIntegration, (match) => {
				// // console.log("IFTTT Replace/Match", match[1], eval(match[1]));
				return eval(match[1]); // eslint-disable-line
			});
			result = JSON.parse(resolvedStrIntegration);
			// // console.log("IFTTT Resolved:", result);
		} catch (e) {
			console.warn("Failed to resolve integration", e);
		}
	}

	return result;
}

function addIntegrationToCollection(integration, item) {
	const _integration = resolveIntegration(integration, item);

	// console.log("IFTTT: Adding integration", _integration);
	switch (_integration.type) {
	case "calculation": {
		if (!state.exists([PROP_APP_STATE, PROP_IFTTT, PROP_CALCULATIONS])) {
			state.set([PROP_APP_STATE, PROP_IFTTT, PROP_CALCULATIONS], []);
		}

		state.push([PROP_APP_STATE, PROP_IFTTT, PROP_CALCULATIONS], _integration);
		break;
	}
	case "rule": {
		if (!state.exists([PROP_APP_STATE, PROP_IFTTT, PROP_RULES])) {
			state.set([PROP_APP_STATE, PROP_IFTTT, PROP_RULES], []);
		}
		state.push([PROP_APP_STATE, PROP_IFTTT, PROP_RULES], _integration);
		break;
	}
	default: {
		throw new Error("Unknown integration of type: " + _integration.type);
	}
	}
}

function addIftttItemsToCollections(iftttItem, item) {
	let iftttItems = [];
	if (!_.isArray(iftttItem)) {
		iftttItems.push(iftttItem);
	} else {
		iftttItems = iftttItem;
	}
	// console.log("IFTTT: Adding items", iftttItems);
	iftttItems.forEach(_iftttItem => {
		if (_iftttItem.ifThis) {
			addIntegrationToCollection(_iftttItem.ifThis, item);
		}
		if (_iftttItem.thenThat) {
			addIntegrationToCollection(_iftttItem.thenThat, item);
		}
	});
}

function parseCurrentActivity(activity, basePath = []) {
	const path = getCurrentActivityKeyPath(basePath);

	let obj = state.get(path);
	if (obj) {
		if (obj.hasOwnProperty(PROP_IFTTT)) {
			addIftttItemsToCollections(obj[PROP_IFTTT], obj);
		}

		_.keys(obj).forEach(key => {
			if (_.isObject(obj[key]) && obj[key].hasOwnProperty("type") && obj[key].type === PROP_IFTTT) {
				addIftttItemsToCollections(obj[key], obj);
			}
		});

		if (obj.hasOwnProperty(PROP_CHILDREN)) {
			obj[PROP_CHILDREN].forEach((child, idx) => {
				const newPath = Object.assign([], basePath);
				newPath.push(idx);
				parseCurrentActivity(activity, newPath);
			});
		}
	}
}

function resetCache() {
	state.set([PROP_APP_STATE, PROP_IFTTT], {});
	// This is necessary right now because we have lookup in two different places
	// this needs to be consolidated.
	clearPathCaches();
	Utils.clearPathCaches();
}

function initializeActivity(activity) {
	// Will reset previously cached information about the current activity
	resetCache();
	// Will parse the cureent activity for IFTTT entries and sort them out for the appropriate services.
	parseCurrentActivity(activity);
}

function getCalculations() {
	return getIntegrationItems(PROP_CALCULATIONS);
}

function getRules() {
	return getIntegrationItems(PROP_RULES);
}

function getIntegrationItems(integrationType) {
	let integrationItems = [];
	if (state.exists([PROP_APP_STATE, PROP_IFTTT, integrationType])) {
		integrationItems = state.get([PROP_APP_STATE, PROP_IFTTT, integrationType]);
	}
	return integrationItems;
}

export function initializeOrchestrator() {
	// console.log("IFTTT: Initializing/Resetting");
	const activity = state.get(["activity"]);
	if (!activity || _.isEmpty(activity)) {
		// Ignore if no activity has been initialized
		return;
	}

	initializeActivity();

	global.pubSubProvider = PubSub; // eslint-disable-line
	global.pubSubProvider.clearAllSubscriptions();// eslint-disable-line
	const calculations = getCalculations();
	let variables = getVariables();
	const rules = getRules();
	// console.log("initializing calculator with", calculations, variables, rules);

	services.rulesEngine = new RulesEngine(rules, global.pubSubProvider); // eslint-disable-line
	services.rulesEngine.addCapability("valueAssignment", (keyPath, value) => {
		// console.log("IFTTT: PUB/SUB value assignment request", keyPath, value);
		const itemPath = _.dropRight(keyPath);
		const prop = _.last(keyPath);
		const item = state.get(itemPath);
		// This is somewhat hacky here ... we are mimicing the way the value is
		// set in actions, feels as though this needs to be centralized and reworked
		// a little bit.

		if (prop === "value") {
			// 	// console.log("IFTTT VARIABLE VALUE SET REQUEST - valueAssignment", keyPath);
			const _item = getObjectByGuid(_.last(itemPath));
			setValueIfHasIdOrchestratedSync(_item, value).then(() => {
				if (_item && _item.hasOwnProperty("valueTrigger") && _item.valueTrigger !== "") {
					let AmbiFi = RuntimeApi; // eslint-disable-line
					eval(item.valueTrigger); // eslint-disable-line
					//tree.set(["session"], tree.get(["session"]) + 1);
				}
				state.set(determineFinalOverrideKeyPath(keyPath, itemPath, prop), value);
			});
		} else {
			state.set(determineFinalOverrideKeyPath(keyPath, itemPath, prop), value);
		}
	});

	global.pubSubProvider.subscribe(CHANNEL_CALCULATIONS_UPDATED, (msg, data) => { // eslint-disable-line
		// console.log("IFTTT: PUB/SUB calcs updated", msg, data);
		// global.pubSubProvider.publish(CHANNEL_SOURCE_CHANGED, data);
		services.rulesEngine.processInput(data);
		// console.log(new Date().getTime(), "IFTTT: RULES EXECUTED", rulesExecuted);
	});
	services.calculator = new Calculator(calculations, variables, global.pubSubProvider); // eslint-disable-line
}


function determineFinalOverrideKeyPath(keyPath, itemPath, prop) {
	let result = keyPath;
	// Fix the old currentChecklist paths
	if (_.first(itemPath) === "currentChecklist") {
		itemPath.splice(0, 1, "activity");
	}
	const curOverrides = state.get(itemPath);
	// console.log("Determining overrides", curOverrides);
	if (curOverrides && curOverrides.hasOwnProperty("targetGuid")) {
		// Direct this elsewhere!
		// console.log("Need to correct...");
		result = _.concat(_.dropRight(itemPath), curOverrides.targetGuid, prop);
		// console.log("Corrected key path, due to forward pointer", itemPath);
	}
	// Fix the old currentChecklist paths
	if (_.first(result) === "currentChecklist") {
		result.splice(0, 1, "activity");
	}

	return result;
}

function flattenObjectArray(value) {
	let result = value;
	if (value && _.isArray(value)) {
		result = [];

		// Inspect to see if all values are Objects and flatten
		value.forEach(item => {
			if (_.isObject(item) && item.hasOwnProperty("value")) {
				// Extract value if this is a value bearing object, otherwise we'll just push what was there
				result.push(item.value);
			} else {
				result.push(item);
			}
		});
	}
	return result;
}

export function setValueIfHasIdOrchestratedSync(item, value) {
	return new Promise((resolve, reject) => {
		try {
			// console.log("IFTTT VARIABLE VALUE SET REQUEST", item, value);
			const variableStateChange = setValueIfHasId(item, value, false);

			if (variableStateChange) {
				_.keys(variableStateChange).forEach(key => {
					let variable = variableStateChange[key];
					if (variable && variable.value && _.isArray(variable.value)) {
						variable.value = flattenObjectArray(variable.value);
					}
				});
				// Ok variable was set.
				const calculationResults = services.calculator.handleVariableStateChange(variableStateChange, false);
				// console.log("IFTTT VARIABLE STATE", variableStateChange, services.calculator.variableState);
				services.rulesEngine.processInput(calculationResults);
				resolve();
			} else {
				resolve();
			}
		} catch (e) {
			console.error(e);
			reject(e);
		}
	});

}